import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6428ea70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "measurement-detail-layout"
}
const _hoisted_2 = { class: "measurement-detail-type" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mr-m"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("POZASTAVENO")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pustit ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Pozastavit ")
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-external-link ml-xs" }, null, -1))
const _hoisted_10 = {
  key: 0,
  style: {"display":"inline-block","padding-right":"10px"}
}
const _hoisted_11 = { style: {"display":"inline-block"} }
const _hoisted_12 = {
  key: 0,
  style: {"padding-top":"20px"}
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Vytvořeno přes externí API")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Editovat měření ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Odstranit měření ")
const _hoisted_16 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_17 = { style: {"padding-bottom":"10px"} }
const _hoisted_18 = { style: {"padding-bottom":"10px","width":"100%","text-align":"right"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Zrušit editaci ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Uložit Trello ID ")
const _hoisted_22 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_23 = {
  key: 0,
  style: {"padding-bottom":"10px","width":"100%"}
}
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Trello ID kartičky není vyplněno")
const _hoisted_27 = { style: {"text-align":"right"} }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Editovat ID Trello kartičky ")

import BaseBox from '@/components/layout/BaseBox.vue';
import BaseFlex from '@/components/layout/BaseFlex.vue';
import BaseCode from '@/components/ui/BaseCode.vue';
import { useRoute, useRouter } from 'vue-router';
import {
	NDescriptions,
	NTag,
	NText,
	NInput,
	NDescriptionsItem,
	NButton,
	useMessage,
	useDialog,
} from 'naive-ui';
import { API } from '@/api';
import { computed, h, onBeforeMount, ref, watch } from 'vue';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';
import NotFoundContent from '@/components/NotFoundContent.vue';
import { useStore } from 'vuex';
import { getResponseMessage } from '@/utils';
import { DateTime, Settings } from 'luxon';
import MeasurementForm from '@/forms/MeasurementForm.vue';
import MeasurementInfo from '@/components/ui/MeasurementInfo.vue';
import { TRELLO_BASE_URL } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

Settings.defaultLocale = 'cs';

const route = useRoute();
const notFound = ref<boolean>(false);
const { push: pushRoute } = useRouter();
const { dispatch } = useStore();
const pending = ref<boolean>(true);
const isEditing = ref<boolean>(false);
const itemInfo = ref<Measurement | undefined>();

const message = useMessage();
const dialog = useDialog();
const today = ref<DateTime>(DateTime.local());
const trelloIdValue = ref<string | null>(null);
const trelloEditOpened = ref(false);

const tagType = computed<'error' | 'info' | 'warning' | 'success' | 'default'>(() => {
	if (itemInfo.value?.type_name) {
		if (itemInfo.value?.type_name.match(new RegExp('PR článek', 'ig'))) {
			return 'error'; // PR článek
		}
		if (itemInfo.value?.type_name.match(new RegExp('SEO článek', 'ig'))) {
			return 'info'; // SEO článek
		}
		if (itemInfo.value?.type_name.match(new RegExp('Native', 'ig'))) {
			return 'warning'; // Native
		}
		if (itemInfo.value?.type_name.match(new RegExp('Redakční článek', 'ig'))) {
			return 'success'; // Redakční článek
		}
	}
	return 'default';
});

const impressionHtml = computed<string>(() => {
	return itemInfo.value?.impression_html || '';
});

const createdInfo = computed<string>(() => {
	if (typeof itemInfo.value?.created_at !== 'string') return '?';

	const date = DateTime.fromISO(itemInfo.value.created_at).toFormat('dd.LL.yyyy - HH:mm');

	if (itemInfo.value?.created_by_name) return `(${date})`;

	return date;
});

const clickLinks = computed<Measurement.ClickLink[]>(() => {
	if (
		typeof itemInfo.value?.click_links !== 'undefined' &&
		Array.isArray(itemInfo.value?.click_links) &&
		itemInfo.value?.click_links.length > 0
	) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return itemInfo.value?.click_links.map((item: string) => {
			if (typeof item === 'string') {
				return { url: decodeURIComponent(item.split('redirect_to=')[1]), urlLink: item };
			}
			return item;
		});
		// return itemInfo.value?.click_links;
	}

	return [];
});

const itemStatus = computed<{ label: string; showChangeButton: boolean; isPaused: boolean }>(() => {
	const isPaused = !!itemInfo.value?.is_paused;
	const startDate: undefined | DateTime =
		typeof itemInfo.value?.start_date === 'string'
			? DateTime.fromISO(itemInfo.value?.start_date).startOf('day')
			: undefined;
	const endDate: undefined | DateTime =
		typeof itemInfo.value?.end_date === 'string'
			? DateTime.fromISO(itemInfo.value?.end_date).endOf('day')
			: undefined;
	if (startDate && endDate) {
		if (startDate > today.value) {
			return { label: 'Plánované měření', showChangeButton: true, isPaused };
		}
		if (endDate < today.value) {
			return { label: 'Proběhlé měření', showChangeButton: false, isPaused };
		}
		if (startDate <= today.value && endDate >= today.value) {
			return { label: 'Aktuální měření', showChangeButton: true, isPaused };
		}
	}

	return { label: '-', showChangeButton: false, isPaused };
});

const idItem = computed<string | undefined>(() =>
	typeof route.params.id === 'string' ? route.params.id : undefined
);

const fetchList = () => dispatch('measurement/fetchData', true);

const setEditing = (): void => {
	isEditing.value = true;
};
const unsetEditing = (): void => {
	isEditing.value = false;
};

const openEditTrelloId = () => {
	if (itemInfo.value?.trello_id) {
		trelloIdValue.value = itemInfo.value.trello_id;
	}

	trelloEditOpened.value = true;
};

const cancelEditTrelloId = () => {
	trelloIdValue.value = null;
	trelloEditOpened.value = false;
};

const fetchItem = async (): Promise<void> => {
	if (typeof idItem.value === 'undefined') {
		return;
	}
	notFound.value = false;

	if (!pending.value) {
		pending.value = true;
	}
	try {
		const dataResponse = await API.measurement.getMeasurement(idItem.value);
		if (typeof dataResponse.payload === 'object' && dataResponse.payload !== null) {
			const measurementData: Measurement = dataResponse.payload as Measurement;

			if (measurementData.deleted_at) {
				notFound.value = true;
			} else {
				itemInfo.value = measurementData;
			}
		}
		pending.value = false;
	} catch (error) {
		const fetchError: AjaxResponseDto = error as AjaxResponseDto;
		if (
			typeof fetchError === 'object' &&
			fetchError !== null &&
			'payload' in fetchError &&
			typeof fetchError?.payload === 'object' &&
			fetchError?.payload !== null &&
			!Array.isArray(fetchError?.payload)
		) {
			if (fetchError?.payload?.code === 404) {
				notFound.value = true;
			} else if (typeof fetchError?.payload?.message === 'string') {
				message.error(fetchError?.payload?.message || 'Neznámá chyba načtení měření');
			} else {
				message.error('Neznámá chyba načtení měření');
			}
		}
		pending.value = false;
	}
};

const saveTrelloId = async () => {
	if (!itemInfo.value?.id) return;

	try {
		await API.measurement
			.updateMeasurementTrelloId(itemInfo.value.id, trelloIdValue.value || null)
			.catch((error) => {
				const catchError: AjaxResponseDto = error as AjaxResponseDto;
				const responseMessage: string | undefined = getResponseMessage(catchError);

				throw new Error(responseMessage || 'Nepodařilo se uložit Trello ID');
			});

		message.success('Trello ID bylo úspěšně uloženo');
	} catch (error) {
		if (error instanceof Error) {
			message.error(error.message);
		}
	}

	await fetchItem();
	fetchList();

	trelloIdValue.value = null;
	trelloEditOpened.value = false;
};

const deleteItem = async () => {
	if (typeof idItem.value === 'undefined') {
		return;
	}
	if (itemInfo?.value?.deleted_at) {
		return;
	}

	pending.value = true;

	try {
		const response: AjaxResponseDto = await API.measurement.deleteMeasurement(idItem.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchList();
		await pushRoute('/mereni/prehled');
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const saveTrelloIdPrompt = async () => {
	dialog.warning({
		title: 'Editace Trello ID',
		content: () =>
			h('div', [
				h('p', { style: { textAlign: 'center' } }, `Skutečně chcete uložit toto Trello ID?`),
				h(
					'div',
					{
						style: {
							fontWeight: 'bold',
							textAlign: 'center',
							paddingTop: '15px',
							paddingBottom: '15px',
						},
					},
					[h('p', { style: { fontSize: '18px' } }, `${trelloIdValue.value || '- Prázdné -'}`)]
				),
			]),
		positiveText: 'Ano, uložit',
		negativeText: 'Ne, neukládat',
		onPositiveClick: async () => {
			dialog.destroyAll();
			await saveTrelloId();
		},
		onNegativeClick: () => {
			dialog.destroyAll();
		},
	});
};

const deleteItemPrompt = async () => {
	if (typeof idItem.value === 'undefined') {
		return;
	}
	if (itemInfo?.value?.deleted_at) {
		return;
	}
	dialog.error({
		title: 'Odstranění měření',
		content: () =>
			h('div', [
				h('p', { style: { textAlign: 'center' } }, `Skutečně chcete odstranit tohoto měření?`),
				h(
					'div',
					{
						style: {
							fontWeight: 'bold',
							textAlign: 'center',
							paddingTop: '15px',
							paddingBottom: '15px',
						},
					},
					[
						h('p', { style: { fontSize: '18px' } }, `${itemInfo.value?.name}`),
						h('p', itemInfo.value?.client_name),
						h('p', itemInfo.value?.campaign_name),
					]
				),
			]),
		positiveText: 'Ano, odstranit',
		negativeText: 'Ne, ponechat',
		onPositiveClick: async () => {
			dialog.destroyAll();
			await deleteItem();
		},
		onNegativeClick: () => {
			dialog.destroyAll();
		},
	});
};

const unpauseItem = async () => {
	if (typeof idItem.value === 'undefined') {
		return;
	}
	if (itemInfo?.value?.deleted_at) {
		return;
	}
	pending.value = true;
	try {
		const response: AjaxResponseDto = await API.measurement.unpauseMeasurement(idItem.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchItem();
		fetchList();
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const pauseItem = async () => {
	if (typeof idItem.value === 'undefined') {
		return;
	}
	if (itemInfo?.value?.deleted_at) {
		return;
	}
	pending.value = true;
	try {
		const response = await API.measurement.pauseMeasurement(idItem.value);
		const responseMessage: string | undefined = getResponseMessage(response);
		if (responseMessage) {
			message.success(responseMessage);
		}
		await fetchItem();
		fetchList();
	} catch (error) {
		const catchError: AjaxResponseDto = error as AjaxResponseDto;
		const responseMessage: string | undefined = getResponseMessage(catchError);
		if (responseMessage) {
			message.error(responseMessage);
		}
		pending.value = false;
	}
};

const editSuccess = async () => {
	unsetEditing();
	await fetchItem();
};

onBeforeMount(async () => {
	await fetchItem();
});

watch(
	() => route.params.id,
	async (newVal, oldVal) => {
		if (typeof newVal === 'string' && newVal !== '' && newVal !== oldVal) {
			await fetchItem();
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (notFound.value)
    ? (_openBlock(), _createBlock(NotFoundContent, {
        key: 0,
        status: "404",
        title: "Měření nenalezen",
        "redirect-link": "/mereni/prehled",
        "redirect-text": "Přejít na přehled měření"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseFlex, {
          row: "",
          "row-gap": "15px",
          "col-gap": "15px",
          wrap: "wrap"
        }, {
          default: _withCtx(() => [
            (isEditing.value)
              ? (_openBlock(), _createBlock(BaseFlex, {
                  key: 0,
                  col: "",
                  "class-name": "measurement-edit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(BaseBox, { title: "Editace měření" }, {
                      default: _withCtx(() => [
                        _createVNode(MeasurementForm, {
                          "is-edit": "",
                          "edit-data": itemInfo.value,
                          onEditSuccess: editSuccess,
                          onEditClose: unsetEditing
                        }, null, 8, ["edit-data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(BaseFlex, {
                  key: 1,
                  col: "",
                  "class-name": "measurement-basic-info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(BaseBox, { title: "Základní informace" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_unref(NTag), {
                            size: "medium",
                            type: _unref(tagType)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(itemInfo.value?.type_name || 'neuvedeno'), 1)
                            ]),
                            _: 1
                          }, 8, ["type"])
                        ]),
                        _createVNode(_unref(NDescriptions), {
                          "label-placement": "top",
                          column: 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptionsItem), { label: "Název" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(itemInfo.value?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Web" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(itemInfo.value?.web_name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Období měření" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(typeof itemInfo.value?.start_date === 'string'
									? _unref(DateTime).fromISO(itemInfo.value?.start_date).toFormat('dd.LL.yyyy')
									: '?') + " - " + _toDisplayString(typeof itemInfo.value?.end_date === 'string'
									? _unref(DateTime).fromISO(itemInfo.value?.end_date).toFormat('dd.LL.yyyy')
									: '?'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Stav měření" }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_unref(itemStatus).label), 1),
                                (_unref(itemStatus).showChangeButton)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                      (_unref(itemStatus).isPaused)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                            _createVNode(_unref(NText), { type: "warning" }, {
                                              default: _withCtx(() => [
                                                _hoisted_5
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_unref(itemStatus).isPaused)
                                        ? (_openBlock(), _createBlock(_unref(NButton), {
                                            key: 1,
                                            size: "small",
                                            type: "success",
                                            tertiary: "",
                                            onClick: unpauseItem
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_6
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_unref(NButton), {
                                            key: 2,
                                            size: "small",
                                            type: "error",
                                            tertiary: "",
                                            onClick: pauseItem
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_7
                                            ]),
                                            _: 1
                                          }))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Klient" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(itemInfo.value?.client_name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Kampaň" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(itemInfo.value?.campaign_name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Obchodník" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(itemInfo.value?.sales_person_name), 1)
                              ]),
                              _: 1
                            }),
                            (itemInfo.value?.url)
                              ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                  key: 0,
                                  label: "URL článku"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", {
                                      href: itemInfo.value?.url,
                                      target: "_blank"
                                    }, [
                                      _createTextVNode(_toDisplayString(itemInfo.value?.url) + " ", 1),
                                      _hoisted_9
                                    ], 8, _hoisted_8)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(NDescriptionsItem), {
                              label: itemInfo.value?.created_by_name ? 'Vytvořil' : 'Vytvořeno'
                            }, {
                              default: _withCtx(() => [
                                (itemInfo.value?.created_by_name)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(itemInfo.value?.created_by_name), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(createdInfo)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        (itemInfo.value?.created_by_id !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_unref(NText), {
                                type: "error",
                                italic: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(BaseFlex, {
                          row: "",
                          justify: "space-around",
                          class: "pt-xl",
                          "col-gap": "20px",
                          "row-gap": "20px",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NButton), {
                              size: "small",
                              type: "warning",
                              tertiary: "",
                              onClick: setEditing
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NButton), {
                              size: "small",
                              type: "error",
                              secondary: "",
                              onClick: deleteItemPrompt
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (pending.value)
                      ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })),
            (!isEditing.value)
              ? (_openBlock(), _createBlock(BaseFlex, {
                  key: 2,
                  col: "",
                  "class-name": "measurement-code",
                  "row-gap": "15px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(BaseBox, { title: "Měření" }, {
                      default: _withCtx(() => [
                        _createVNode(BaseFlex, {
                          row: "",
                          "col-gap": "15px",
                          "row-gap": "15px",
                          justify: "space-around",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(MeasurementInfo, {
                              label: "Imprese",
                              value: itemInfo.value?.impressions_count || 0,
                              target: itemInfo.value?.impressions_target || 0
                            }, null, 8, ["value", "target"]),
                            _createVNode(MeasurementInfo, {
                              label: "Kliky",
                              value: itemInfo.value?.clicks_count || 0,
                              target: itemInfo.value?.clicks_target || 0
                            }, null, 8, ["value", "target"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(BaseBox, { title: "Trello" }, {
                      default: _withCtx(() => [
                        _createVNode(BaseFlex, {
                          row: "",
                          "col-gap": "15px",
                          "row-gap": "15px",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (trelloEditOpened.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_unref(NInput), {
                                      value: trelloIdValue.value,
                                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((trelloIdValue).value = $event)),
                                      type: "text",
                                      placeholder: "ID Trello kartičky"
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_unref(NButton), {
                                      size: "small",
                                      type: "error",
                                      tertiary: "",
                                      onClick: cancelEditTrelloId
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_20,
                                    _createVNode(_unref(NButton), {
                                      size: "small",
                                      type: "success",
                                      onClick: saveTrelloIdPrompt
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_21
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (itemInfo.value?.trello_id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("a", {
                                          href: `${_unref(TRELLO_BASE_URL)}/${itemInfo.value?.trello_id}`,
                                          target: "_blank"
                                        }, " Přejít na Trello kartičku ", 8, _hoisted_24)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createVNode(_unref(NText), { italic: "" }, {
                                          default: _withCtx(() => [
                                            _hoisted_26
                                          ]),
                                          _: 1
                                        })
                                      ])),
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_unref(NButton), {
                                      size: "small",
                                      type: "warning",
                                      tertiary: "",
                                      onClick: openEditTrelloId
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_28
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(BaseBox, { title: "Odkazy" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptions), {
                          "label-placement": "top",
                          column: 1
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDescriptionsItem), { label: "Impresní pixel" }, {
                              default: _withCtx(() => [
                                _createVNode(BaseCode, { code: _unref(impressionHtml) }, null, 8, ["code"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NDescriptionsItem), { label: "Proklikové URL" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clickLinks), (clickLink, index) => {
                                  return (_openBlock(), _createBlock(BaseCode, {
                                    key: index,
                                    title: clickLink.url,
                                    code: clickLink.urlLink
                                  }, null, 8, ["title", "code"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
}
}

})